import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../model/user.model';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class AutoremindTranslateService {

  constructor(private accountService: AccountService,
              private translateService: TranslateService) {

  }

  loadTranslationByPermission(user: User): void {
    const DEFAULT_TRANSLATION_FILE = 'en_person';
    const VET_TRANSLATION_FILE = 'en_vets';
    const VET_PERMISSION_KEY = 'resource:pets';

    if (this.accountService.hasUserPermissionKey(user, VET_PERMISSION_KEY)) {
      this.translateService.use(VET_TRANSLATION_FILE);
    } else {
      this.translateService.use(DEFAULT_TRANSLATION_FILE);
    }
  }

}
